var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import config from '../config';
import { marketGroupsSortingFunction } from '../services/favouriteCategoriesService';
import { favouriteCategoriesService } from '../services';
import { dataProvider, getEndpoint } from './dataProvider';
const getMarketsUrl = (locale, eventId, useBYOFreedom) => `${config.dataServiceUrl}/${locale}/event/${eventId}/markets${useBYOFreedom ? '/byoFreedom' : ''}`;
const sortMarketsData = (marketsData) => {
    const sortedGroups = (marketsData.byoMarketGroups || []).sort(marketGroupsSortingFunction);
    let lastOrder = 0;
    return Object.assign(Object.assign({}, marketsData), { byoMarketGroups: sortedGroups.map((group) => {
            if (group.order) {
                lastOrder = group.order;
                return group;
            }
            lastOrder += 1;
            return Object.assign(Object.assign({}, group), { order: lastOrder });
        }) });
};
/**
 * Gets event's markets from byo data service
 * @return ByoMarketType
 * @public
 */
export const getMarketsData = (locale, eventId, useBYOFreedom) => __awaiter(void 0, void 0, void 0, function* () {
    const path = getMarketsUrl(locale, eventId, useBYOFreedom);
    const endpoint = getEndpoint(path);
    const marketsData = yield dataProvider(endpoint);
    const sortedMarketsData = sortMarketsData(marketsData);
    const favouritesCategories = favouriteCategoriesService.loadFavouriteCategories();
    return favouriteCategoriesService.getMarketsDataWithFavourites(sortedMarketsData, favouritesCategories);
});
